import { render, staticRenderFns } from "./PatientPlanList.vue?vue&type=template&id=a91cbc8e&scoped=true&"
import script from "./PatientPlanList.vue?vue&type=script&lang=ts&"
export * from "./PatientPlanList.vue?vue&type=script&lang=ts&"
import style0 from "./PatientPlanList.vue?vue&type=style&index=0&id=a91cbc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91cbc8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
